import { apiSlice } from '../api/apiSlice'
import { RequestProps } from '../../types'
import DecisionEnum from '../../types/enums/DecisionEnum'
import RecruitmentsResponse from '../../types/response/RecruitmentsResponse'
import Recruitment from '../../types/models/Recruitment'
import { changeEmptyStringsToNull, changeNullsToEmptyString } from '../../utils/falsyValuesConverter'

const commonUrl = 'recruitments'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getRecruitments: builder.query<RecruitmentsResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: commonUrl,
        params: props,
      }),
      transformResponse: (responseData: RecruitmentsResponse) => {
        return responseData
      },
      providesTags: () => [{ type: 'Recruitment', id: 'LIST' }],
    }),
    getRecruitmentById: builder.query<Recruitment, string>({
      query: (id: string) => `/${commonUrl}/${id}`,
      transformResponse: (responseData: Recruitment) => {
        return changeNullsToEmptyString(responseData)
      },
      providesTags: () => [{ type: 'Recruitment', id: 'LIST' }],
    }),

    createRecruitment: builder.mutation({
      query: (recruitment: Partial<RecruitmentModify>) => ({
        url: commonUrl,
        method: 'POST',
        body: changeEmptyStringsToNull(recruitment),
      }),
      invalidatesTags: () => [
        { type: 'Recruitment', id: 'LIST' },
        { type: 'Candidate', id: 'LIST' },
      ],
    }),

    editRecruitment: builder.mutation<Recruitment, EditArgs>({
      query: ({ id, recruitment }) => {
        let url = `/${commonUrl}/${id}`
        return {
          url: url,
          method: 'PUT',
          body: changeEmptyStringsToNull(recruitment),
        }
      },
      invalidatesTags: () => [
        { type: 'Recruitment', id: 'LIST' },
        { type: 'Candidate', id: 'LIST' },
      ],
    }),

    deleteRecruitment: builder.mutation<Recruitment, string>({
      query: (id: string) => ({
        url: `/${commonUrl}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [
        { type: 'Recruitment', id: 'LIST' },
        { type: 'Candidate', id: 'LIST' },
      ],
    }),
  }),
})

export type RecruitmentModify = {
  candidateId: string
  step: string
  stage: string
  completionDate: string
  responsibles: string[]
  comments: string
  decision: DecisionEnum
  version: number
}

type EditArgs = {
  id: string
  recruitment: Partial<RecruitmentModify>
}

// Generated hooks
export const {
  useCreateRecruitmentMutation,
  useDeleteRecruitmentMutation,
  useEditRecruitmentMutation,
  useLazyGetRecruitmentByIdQuery,
  useGetRecruitmentsQuery,
} = extendedApiSlice